/**
 * W2 §8.6 / G18 / G20 — must match `requireCustomerAuthCsrfHeader` on the API.
 * Admin twin: `adminAuthCsrf.ts` (markers + shouldAttach*).
 *
 * Attach `X-Requested-With: XMLHttpRequest` on every CSRF Yes mutation.
 * G18 honesty: login-password / OTP / forgot-password are CSRF-exempt (Turnstile);
 * refresh / logout / logout-all / set-credentials are CSRF-forced.
 */

export const CUSTOMER_AUTH_CSRF_HEADER = 'X-Requested-With';
export const CUSTOMER_AUTH_CSRF_HEADER_VALUE = 'XMLHttpRequest';

export function customerAuthCsrfHeaders(): Record<string, string> {
  return {
    [CUSTOMER_AUTH_CSRF_HEADER]: CUSTOMER_AUTH_CSRF_HEADER_VALUE,
  };
}

/**
 * Path markers for CSRF Yes mutating routes (T5 / customerAuthCsrfYesRouteMatrix).
 * Matched via `path.includes(marker)` so `/api` + `/api/{tenant}/v1` twins are covered.
 * Safe methods (GET/HEAD/OPTIONS) never attach — see `shouldAttachCustomerAuthCsrf`.
 */
export const CUSTOMER_AUTH_CSRF_YES_PATH_MARKERS = [
  // Session ops — tenant + platform dual-mount
  '/customer-auth/refresh',
  '/customer-auth/logout',
  '/customer-auth/logout-all',
  // OIDC login start (not oidc/session establish)
  '/customer-auth/oidc/start',
  // Wave 4.5 — OIDC phone-gate POSTs exactly (not GET status)
  '/customer-auth/oidc/phone-gate/phone',
  '/customer-auth/oidc/phone-gate/verify-otp',
  '/customer-auth/oidc/phone-gate/complete',
  // Always CSRF (all modes)
  '/customer-auth/set-credentials',
  '/customer-auth/link-account',
  // Step-up
  '/customer-auth/request-step-up',
  '/customer-auth/verify-step-up',
  // Card-link (sibling mount; matrix asserts)
  '/customer/customer-card/link',
  // Wave 3 — platform contact upsert + verify (Profile Ověřit / interstitial / OIDC add-phone)
  '/customer-account/contacts',
  // Directory Sort prefs (Obchody / Organizace / Oblíbené)
  '/customer-account/preferences/directory-ui',
  // Platform-wide cookie / M+A consent (Auth V2)
  '/customer-account/consent/preferences',
  '/customer-account/consent/marketing-analytics-prompt',
] as const;

export function isCustomerAuthCsrfYesPath(path: string): boolean {
  return CUSTOMER_AUTH_CSRF_YES_PATH_MARKERS.some((marker) => path.includes(marker));
}

export function shouldAttachCustomerAuthCsrf(method: string, path: string): boolean {
  const upper = method.toUpperCase();
  if (upper === 'GET' || upper === 'HEAD' || upper === 'OPTIONS') {
    return false;
  }
  return isCustomerAuthCsrfYesPath(path);
}
